"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListItemTitle = exports.StyledFilterItemOption = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _List = require("calcite-react/List");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);
  _templateObject2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", "};\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledFilterItemOption = (0, _styledComponents.default)(_List.ListItem)(_templateObject(), function (_ref) {
  var active = _ref.active;
  return active && "600";
});
exports.StyledFilterItemOption = StyledFilterItemOption;
var StyledListItemTitle = (0, _styledComponents.default)(_List.ListItemTitle)(_templateObject2());
exports.StyledListItemTitle = StyledListItemTitle;